export default __webpack_public_path__ + "trust-black.png";